const isLocalhost =
  typeof window !== "undefined" &&
  ["localhost", "127.0.0.1"].includes(window.location.hostname);

export const API_BASE_URL = isLocalhost
  ? process.env.REACT_APP_LOCAL_API_BASE_URL || "http://localhost:3000"
  : process.env.REACT_APP_API_BASE_URL || "https://genmech-backend-mvbu.onrender.com";

